import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  class: "w100 llgreyBg",
  style: {"height":"40px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "w90 pad15"
}
const _hoisted_9 = {
  key: 1,
  class: "w90 pad15"
}
const _hoisted_10 = {
  key: 2,
  class: "w90 pad15"
}
const _hoisted_11 = {
  key: 3,
  class: "w90 pad15"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_UserSettingsHeader = _resolveComponent("UserSettingsHeader")!
  const _component_UserSettingsLocations = _resolveComponent("UserSettingsLocations")!
  const _component_UserSettingsGroupTags = _resolveComponent("UserSettingsGroupTags")!
  const _component_UserSettingsCustomNotifications = _resolveComponent("UserSettingsCustomNotifications")!
  const _component_UserSettingsDownload = _resolveComponent("UserSettingsDownload")!
  const _component_OptionModal = _resolveComponent("OptionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `settings` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_UserSettingsHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedCategory == `locations` ? `fw600 selected` : ``}`),
                  style: {"width":"60px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategory(`locations`)))
                }, " 場所 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedCategory == `group_tags` ? `fw600 selected` : ``}`),
                  style: {"width":"120px"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategory(`group_tags`)))
                }, " グループタグ ", 2),
                (_ctx.UserPermissionsOption.permitEdit(_ctx.rm.userInfo, `user_settings`, `user_settings_notifications`))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${
                                _ctx.selectedCategory == `notifications` ? `fw600 selected` : ``
                            }`),
                      style: {"width":"120px"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCategory(`notifications`)))
                    }, " 外部通知設定 ", 2))
                  : _createCommentVNode("", true),
                (_ctx.UserPermissionsOption.permitEdit(_ctx.rm.userInfo, `user_settings`, `user_settings_download`))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedCategory == `download` ? `fw600 selected` : ``}`),
                      style: {"width":"120px"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectCategory(`download`)))
                    }, " ダウンロード ", 2))
                  : _createCommentVNode("", true),
                _hoisted_6
              ]),
              _hoisted_7,
              (_ctx.selectedCategory == `locations`)
                ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                    _createVNode(_component_UserSettingsLocations)
                  ]))
                : (_ctx.selectedCategory == `group_tags`)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                      _createVNode(_component_UserSettingsGroupTags)
                    ]))
                  : (_ctx.selectedCategory == `notifications`)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                        _createVNode(_component_UserSettingsCustomNotifications)
                      ]))
                    : (_ctx.selectedCategory == `download`)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                          _createVNode(_component_UserSettingsDownload)
                        ]))
                      : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_12,
      _createVNode(_component_OptionModal, {
        ref: "OptionModal",
        eventName: `${_ctx.rm.showPlanOptionModalWithName} 課金リクエスト`,
        onClickOK: _ctx.clickOK,
        onClickCancel: _ctx.clickCancel,
        onCloseModal: _ctx.closeOptionModal
      }, null, 8, ["eventName", "onClickOK", "onClickCancel", "onCloseModal"])
    ])
  ]))
}